import React, { useEffect } from 'react';
import { MotifButton } from '@ey-xd/motif-react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Container,
  FullScreenContainer,
  Header,
  Text,
  Title,
} from '@organisms/headerComponent/styles/logOutscreenStyles';

const LogOutScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { TITLE, DESCRIPTION, BUTTON_TITLE } = location.state || {};

  useEffect(() => {
    const isRefresh = sessionStorage.getItem('refreshed');

    if (isRefresh) {
      handleRestart();
    } else {
      sessionStorage.setItem('refreshed', true);
    }
  }, []);

  const handleRestart = () => {
    navigate('/');
    window.location.reload();
  };

  return (
    <FullScreenContainer>
      <Container>
        <Header>
          <Title>{TITLE}</Title>
          <Text>{DESCRIPTION}</Text>
        </Header>
        <MotifButton variant="primary-alt" onClick={handleRestart}>
          {BUTTON_TITLE}
        </MotifButton>
      </Container>
    </FullScreenContainer>
  );
};

export default LogOutScreen;
